export default __webpack_public_path__ + "static/media/Pharmacy_team_guide.04b4038c.pdf";